import React from 'react';
import PropTypes from 'prop-types';

const Image = ({ openLightbox, image }) => (
  <div className="col-md-4 col-ms-6" style={{ marginTop: 20 }}>
    <div className="thumbnail" onClick={openLightbox} role="button" tabIndex={0}>
      <img className="img-responsive" src={`${image.thumbnail}`} alt="" loading="lazy" />
    </div>
  </div>
);

Image.propTypes = {
  openLightbox: PropTypes.func.isRequired,
  image: PropTypes.shape({
    thumbnail: PropTypes.string.isRequired,
  }).isRequired,
};

export default Image;
